/* eslint-disable no-unused-vars */
enum StructureType {
  business = 'Business',
  manufacturedHome = 'Manufactured Home',
  multiFamily = 'Multi Family',
  singleFamily = 'Single Family',
}

export default StructureType;
